import phoneInstance from './instance'

const updatePhone = (data) => {
  return phoneInstance.put('/voip-settings/' + data.id, data)
}

export default updatePhone
